/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WorkloadDeviceJoinToken = {
  /**
   * When the token stops being redeemable.
   */
  expiresAt: Date;
  /**
   * The join token. Shown once; only its hash is stored.
   */
  token: string;
};

/** @internal */
export const WorkloadDeviceJoinToken$inboundSchema: z.ZodMiniType<
  WorkloadDeviceJoinToken,
  unknown
> = z.pipe(
  z.object({
    expires_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    token: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "expires_at": "expiresAt",
    });
  }),
);

export function workloadDeviceJoinTokenFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadDeviceJoinToken, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadDeviceJoinToken$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadDeviceJoinToken' from JSON`,
  );
}
